<script setup lang="ts">
import routeManager from "@/router/route-manager";
import { ref } from "vue";

const home = ref< string >( routeManager.homePath() );
</script>

<template>
  <div class="text-zinc-500 mt-20 text-center space-y-8 container-md">
    <h1 class="text-5xl">404</h1>
    <h1>Page Not Found</h1>
    <p>For assistance, please contact our Customer Care Team at <a class="link-primary font-semibold" href="tel:+18558220269">+1 (855) 822-0269</a> or <a class="link-primary font-semibold" href="mailto:support@truemarketinsiders.com">support@truemarketinsiders.com.</a></p>
    <router-link :to="home" class="btn btn-primary shadow-xl">Back to Home</router-link>
  </div>
</template>
